import { Badge } from '@amzn/awsui-components-core';
import React from 'react';

/**
 * Helper function to render program status badges.
 *
 * This utility is extracted from productHierarchyTableUtils to avoid pulling
 * ag-grid dependencies into components that don't need it (like HomePage widgets).
 *
 * Used by:
 * - LastEditedProgramsWidget (HomePage)
 * - Product Hierarchy Table (Bulk Edit)
 * - Other components displaying program status
 */
export const getProgramStatusBadge = (status: string | null): JSX.Element => {
  switch (status) {
    case null:
    case '':
      return <></>;
    case 'Active':
      return <Badge color="green">{status}</Badge>;
    case 'Cancelled':
    case 'EOL':
      return <Badge color="red">{status}</Badge>;
    case 'Topside':
      return <Badge color="blue">{status}</Badge>;
    default:
      return <Badge color="grey">{status}</Badge>;
  }
};
